import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as IconChevronDown } from '../../../../assets/icons/u_chevron-down.svg';
import { ReactComponent as IconReport } from '../../../../assets/icons/u_reports.svg';
import { ReactComponent as IconChevronUp } from '../../../../assets/icons/u_chevron-up.svg';
import { IAccordanceReportParams } from '../../../../models/AccordanceReportParams';
import { transformAccordancesReportPayload } from '../../../../api/reportApi';
import { ReportStatusEnum } from '../../../../models/ReportEnums';
import { ReportAccordance } from '../../Modals/ReportAccordance/ReportAccordance';
import { ReactComponent as IconOnePager } from '../../../../assets/icons/one-pager.svg';
import { ReactComponent as IconExtendedPager } from '../../../../assets/icons/extended-icon.svg';
import { downloadOnePagerReportFromPayload, downloadOnePagerReportFromProject } from '../../../Reports/OnePagerReport/utils/onePagerReportDownload';
import usePortfolioName from '../../../../hooks/usePortfolioName';
import BaseModal from '../../Modals/BaseModal';
import { styles } from '../../Modals/Styles';
import SpinningLoader from '../../../ProjectDetail/ProjectTabs/Loader/SpinningLoader';
import { getLabelDownloadingReport } from '../../../Projects/ProjectsReport/utils/Validators/ReportValidations';
import AutoDismissAlert from '../../../Projects/ProjectsReport/view/Common/AlertTooltips';
import { ERROR_IN_GENERATE_REPORT, SUCESSFUL_GENERATED_PROJECT_REPORT } from '../../../Projects/ProjectsReport/utils/Constants/AlertStatusConstants';
interface OnePagerReportButtonProps {
  isDisable?: boolean;
  from?: 'project' | 'portfolio';
  projectId?: number | string | null;
  projectCode?: string | null;
  isPMRType?: boolean;
}

const pollingMiliseconds = 20000;

export const OnePagerReportButton = ({
  isDisable,
  from = 'portfolio',
  projectId,
  projectCode,
  isPMRType,
}: OnePagerReportButtonProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const indicatorPayload = useSelector<any, any>(state => state.indicatorPayload.payload);
  const sectorsFromRedux = useSelector<any, any>(state => state.sectors);
  const divisionsFromRedux = useSelector<any, any>(state => state.divisions);
  const portfolioName = usePortfolioName();

  const [isDropMenuOpen, setIsDropMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPortfolioDropdownOpen, setIsPortfolioDropdownOpen] = useState(false);
  const [accordanceReportData, setAccordanceReportData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alertConfig, setAlertConfig] = useState<any>();

  const generateAggrementReport = async (accordanceParams: IAccordanceReportParams) => {
    const transformedPayload = transformAccordancesReportPayload(accordanceParams);
    return transformedPayload;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!accordanceReportData.some(item => item.reportStatus === ReportStatusEnum.Generating)) {
        return () => clearInterval(interval);
      }
      return true;
    }, pollingMiliseconds);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accordanceReportData]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsDropMenuOpen(false);
        setIsPortfolioDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOnePagerDownload = async () => {
    try {
      let isSuccessful = false;
      if (from === 'project') {
        isSuccessful = await downloadOnePagerReportFromProject({
          projectId,
          onLoading: setIsLoading,
        });
      } else {
        isSuccessful = await downloadOnePagerReportFromPayload({
          indicatorPayload,
          sectors: sectorsFromRedux,
          divisions: divisionsFromRedux,
          portfolioName: portfolioName || '',
          onLoading: setIsLoading,
        });
      }
      setAlertConfig(isSuccessful ? SUCESSFUL_GENERATED_PROJECT_REPORT : ERROR_IN_GENERATE_REPORT);
    } catch (error) {
      setAlertConfig(ERROR_IN_GENERATE_REPORT);
      console.error('Error generating one pager report', error);
    } finally {
      setIsDropMenuOpen(false);
      setIsPortfolioDropdownOpen(false);
    }
  };
  return (
    <div style={{ position: 'relative' }} ref={containerRef}>
      <button
        className={`${isDisable ? 'btn btn-primary-outlined disabled' : 'btn btn-primary-outlined'
          } report-button-container--indexable`}
        disabled={isDisable}
        defaultValue="acuerdos"
        onClick={() => setIsDropMenuOpen(!isDropMenuOpen)}
      >
        <IconReport style={{ marginRight: '8px' }} />{t('one_pager_report.generate_report')}{' '}
        {isDropMenuOpen ? <IconChevronUp /> : <IconChevronDown />}
      </button>
      {isDropMenuOpen && (
        <div className="dropdown-menu">
          <ul>
            <li className="portfolio-report-item">
              <div
                className="dropdown-toggle-wrapper"
                onClick={() => setIsPortfolioDropdownOpen(!isPortfolioDropdownOpen)}
              >
                <span>{t('one_pager_report.portfolio_report')}</span>
                <IconChevronDown style={{ transform: 'rotate(-90deg)' }} />
              </div>
              {isPortfolioDropdownOpen && (
                <div className="nested-dropdown-left">
                  <div
                    className="nested-option"
                    onClick={() => handleOnePagerDownload()}
                  >
                    <IconOnePager />
                    <div className="option-content">
                      <div className="option-title">{t('one_pager_title')}</div>
                      <div className="option-subtitle">{t('overall_portfolio_summary')}</div>
                    </div>
                  </div>
                  <div
                    className="nested-option"
                    onClick={() => {
                      if (from === 'project') {
                        const query = `from=project&id=${projectId}&code=${projectCode || ''}&isPMRType=${Boolean(isPMRType)}`;
                        history.push(`/extendedreport?${query}`);
                        return;
                      }
                      history.push('/extendedreport');
                    }}
                  >
                    <IconExtendedPager />
                    <div className="option-content">
                      <div className="option-title">{t('extended_title')}</div>
                      <div className="option-subtitle">{t('sectional_analysis')}</div>
                    </div>
                  </div>
                </div>
              )}
            </li>
            {(from !== 'project') && (
              <li onClick={() => setIsModalOpen(true)}>{t('one_pager_report.aggrements_report')}</li>
            )}
          </ul>
        </div>
      )}
      {isModalOpen &&
        <ReportAccordance closeModal={() => setIsModalOpen(false)} isOpen={isModalOpen} submit={generateAggrementReport} />
      }
      <BaseModal
        isOpen={isLoading}
        style={styles}
        className="downloading-report"
      >
        <SpinningLoader customStyle={{ marginTop: 0 }} customText={getLabelDownloadingReport(from)} />
      </BaseModal>
      {alertConfig && (
        <AutoDismissAlert
          message={alertConfig.message}
          title={alertConfig.title}
          severity={alertConfig.severity}
          duration={alertConfig.duration}
          onClose={() => setAlertConfig(null)}
        />
      )}
    </div>
  );
};





